import { Button, Form, notification, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";
import { useParams } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { editMainWebsiteCategoryTitle, getMainWebsiteByID } from "../actions";

type Props = {
  fetchData: () => void;
};

interface FormValues {
  title: {
    en: string;
    ar: string;
    fr: string;
  };
}

const EditCategoryTitle: React.FC<Props> = ({ fetchData }) => {
  const { id, categoryId } = useParams();

  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const fetchItem = async () => {
    setIsLoading(true);
    const ft = await getMainWebsiteByID(id!);
    if (ft) {
      const ft_cat = ft.Categories.find((cat) => cat.id === categoryId);
      form.setFieldsValue({
        title: {
          en: ft_cat?.MainInfo.Title.En,
          ar: ft_cat?.MainInfo.Title.Ar,
          fr: ft_cat?.MainInfo.Title.Fr,
        },
      });
    }

    setIsLoading(false);
  };

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await editMainWebsiteCategoryTitle(
        id!,
        categoryId!,
        formValues.title
      );

      if (data) {
        fetchData();
        api.success({
          message: "Category edited successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to edit category",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchItem();
  }, [id]);

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="title" label="Title" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this category?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<FaEdit />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Editing Category..." : "Edit Category"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default EditCategoryTitle;
